import React from 'react'
import { Card, Image } from 'react-bootstrap'
import './style.scss'

const BestSaleSlider = ({ data = [] }) => {
  const bestSaleItems = [
    {
      id: 1,
      title: 'Item 1',
      price: '100',
      img: 'https://via.placeholder.com/150',
    },
    {
      id: 2,
      title: 'Item 2',
      price: '200',
      img: 'https://via.placeholder.com/150',
    },
    {
      id: 3,
      title: 'Item 3',
      price: '300',
      img: 'https://via.placeholder.com/150',
    },
    {
      id: 4,
      title: 'Item 4',
      price: '400',
      img: 'https://via.placeholder.com/150',
    },
    {
      id: 5,
      title: 'Item 5',
      price: '500',
      img: 'https://via.placeholder.com/150',
    },
    {
      id: 6,
      title: 'Item 6',
      price: '600',
      img: 'https://via.placeholder.com/150',
    },
    {
      id: 7,
      title: 'Item 7',
      price: '700',
      img: 'https://via.placeholder.com/150',
    },
    {
      id: 8,
      title: 'Item 8',
      price: '800',
      img: 'https://via.placeholder.com/150',
    },
  ]

  return (
    <div className='container my-4'>
      <h2 className='text-center mb-4 text-success'>Top Sales</h2>
      {/* <div className='best-sale-carousel' data-bs-ride='carousel'>
        <div className='best-sale-carousel-track'>
          {bestSaleItems.map((item) => (
            <Card className='mx-2 best-sale-card' key={item.id}>
              <img src={item.img} className='' alt={item.title} />
              <Card.Body className=' text-center'>
                <Card.Title>{item.title}</Card.Title>
                <Card.Text>{item.price}</Card.Text>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div> */}

      {/* <div className="carousel">
        <div className="group">
          <div className="card">A</div>
          <div className="card">B</div>
          <div className="card">C</div>
        </div>
        <div aria-hidden="true" className="group">
          <div className="card">A</div>
          <div className="card">B</div>
          <div className="card">C</div>
        </div>
      </div> */}

      <div className='best-sale-carousel'>
        <div className='group'>
          {data.map((item) => (
            <Card className='mx-2 pointer overflow-hidden' key={item.id}>
              <Image
                src={item.user_image}
                style={{ height: 200, width: 200 }}
                className=''
                alt={item.title}
              />
              <Card.Body className=' text-center'>
                <Card.Title>{item.firstname + ' ' + item.lastname}</Card.Title>
                <Card.Text>Order Amount:<br /><span className='text-success text-bold'>{item.order_amount}</span> TK</Card.Text>
              </Card.Body>
            </Card>
          ))}
        </div>
        <div aria-hidden='true' className='group'>
          {data.map((item) => (
            <Card className='mx-2 pointer overflow-hidden' key={item.id}>
              <Image
                src={item.user_image}
                style={{ height: 200, width: 200 }}
                className=''
                alt={item.title}
              />
              <Card.Body className=' text-center'>
                <Card.Title>{item.firstname + ' ' + item.lastname}</Card.Title>
                <Card.Text>Order Amount:<br /><span className='text-success text-bold'>{item.order_amount}</span> TK</Card.Text>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}

export default BestSaleSlider
